import { render } from "./LoginLinks.vue?vue&type=template&id=ac280572&scoped=true"
const script = {}

import "./LoginLinks.vue?vue&type=style&index=0&id=ac280572&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac280572"]])

export default __exports__